import React, { useContext, useEffect } from 'react';
import { QuestionToAsk, PrintPage } from '../../components';
import userContext from '../../components/ContextComponent/UserContext';
import { AmazonCardRejected } from '../../utils/AmazonPixel';

function GO2Declined({ apiOutput, data }) {
    const { formData } = useContext(userContext);

    useEffect(() => {
        /*window.setITag("confirmation", "success");*/
        window.setPageContext("ThankYou");
    }, []);
    return (
        <div>
            <div className="stack body">
                <div className="pad-responsive">
                    <div className="text-align-center pad-1">
                        Thank you {formData.firstName} for applying for {data.journeyContent.productName}.
                    </div>
                    {
                        (apiOutput.go2ApiPcnNumber != null) &&
                        <div className="text-align-center pad-1">
                            Application Reference No. {apiOutput.go2ApiPcnNumber}
                        </div>
                    }
                    <div className="text-align-center pad-1">
                        After careful consideration, we are sorry to let you know that we will not able to approve your application.
                    </div>
                </div>
                <div className="pad-4">
                    <PrintPage />
                    <QuestionToAsk />
                </div>
            </div>
            <AmazonCardRejected product={data?.selectedProduct} />
        </div>
    );
}
export default GO2Declined;